import React from "react";
import { CarouselSlide } from "theme/components/organisms/Carousel";
import PropTypes from "prop-types";
import Link from "theme/components/atoms/Typography/Link";

/** @type {React.FunctionComponent<SliderProps>} */
const Slide = ({ children, data, className = "" }) => {
  const CarouselFragment = (
    <div className={className}>
      <CarouselSlide
        imageSrc={data.desktopImage}
        mobileImage={data.mobileImage}
        data-pb-style={data.styleId}
        aria-label={data.slideName}
      >
        {children}
      </CarouselSlide>
    </div>
  );

  if (data.link.href) {
    return (
      <Link to={data.link.href} target={data.link.target}>
        {CarouselFragment}
      </Link>
    );
  }

  return CarouselFragment;
};

/** @typedef {PropTypes.InferProps<typeof propTypes>} SliderProps */
const propTypes = {
  data: PropTypes.shape({
    desktopImage: PropTypes.string.isRequired,
    mobileImage: PropTypes.string.isRequired,
    styleId: PropTypes.string.isRequired,
    slideName: PropTypes.string.isRequired,
    link: PropTypes.shape({
      href: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
    }).isRequired,
  }),
  className: PropTypes.string,
};
Slide.propTypes = propTypes;

export default Slide;
